module.exports = __webpack_public_path__ + "img/dots_rbp4.26096cee.png";